export const glossaryOptions = [
    {
        "text": "Yes",
        "value": true
    },
    {
        "text": "No",
        "value": false
    }
]